require("./styles/index.less")
var Cookies = require("js-cookie")
var routes = require("./routes/index")
var c = require("./utiles/common")
var config = require("./utiles/locale/config");
var language = Cookies.get("language")?Cookies.get("language"):"zh_CN";
var common = require('./utiles/common')
console.log(language)
window.commonLocal = config.languagePack(language);
window.setIamLanguage = function(v){
    console.log(v)
}
function startApp() {
    var resizeCount = 0;

    c.baseURI   = window.location.pathname.substr(0,  window.location.pathname.length-1);
    // 使用punches
    ko.punches.enableAll();

    $(window).resize(function () {
        resizeCount++;
        var a = resizeCount;
        setTimeout(function () {
            if (a == resizeCount) {
                c.fixResizeIssue()
            }
        }, 50)
    });

    ko.onError = function (error) {
        // console.log("knockout error", error);
    };


    $(document).ajaxError(function (event, request, settings) {
        // 如果用户未登录、会话过期，则跳转到登录页
        if (request.status == 401) {
            console.log(request)
            // 由于不是json 不能判斷
            if(request.responseText.indexOf("secureClientIssue") > -1){
                common.redirectTo("/#/secureClientMsg");
                return false;
            }
            var responseText = JSON.parse(request.responseText);
            //建行特殊跳转开发--倪林祥
            if(responseText.httpStatus === "REDIRECT_URL" && responseText.redirectUrl){
                common.redirectTo(responseText.redirectUrl);
            // 安全客戶端
            }else if(responseText.secureClientIssue){
                common.redirectTo("/#/secureClientMsg");
            }else{
                if(navigator.userAgent.indexOf("MSIE")!=-1){
                    c.redirectTo("/#/");
                    window.location.reload(); 
                }else{
                    c.redirectTo("/#/")
                }
            }
        }
        if (settings.handleError) {
            settings.handleError(JSON.parse(request.responseText));
        } else {
            // 全局处理错误
            // alert(request.responseText)
        }
    })

    // 设置icon
    if(sessionStorage.getItem("icon")){
        common.changeFavicon(sessionStorage.getItem("icon"));
    }

    // 初始化Routes
    routes.initialRoutes();
}

$(startApp())


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 23
// module chunks = 0